export const NAMESPACE = "EventLightFileRequestsResults";

export const TABLE_INSTANCE_ID = "file-request-results";
export const VIEWPICKER_INSTANCE_ID = "file-request-results";
export const TABLE_VIEW_ID = "file-request-results-table";

export const STATUS = {
  ALL: "all",
  PENDING: "pending",
  IN_REVIEW: "in_review",
  APPROVED: "approved",
  DRAFT: "draft",
  DENIED: "denied"
};

export const ROW_ACTIONS = {
  VIEW_RECORD: "row-viewRecord",
  VIEW_ORIGINAL_SUBMISSION: "row-viewOriginalSubmission",
  SEND_EMAIL: "row-sendEmail",
  EDIT: "row-edit",
  SEND_ALL_ITEMS: "row-sendAllItems",
  SEND_ALL_PASSES: "row-sendAllPasses",
  SEND_ALL_MEALS: "row-sendAllMeals",
  SEND_ALL_PASSES_MEALS: "row-sendAllPassesMeals",
  SEND_ALL_ASSETS: "row-sendAllAssets",
  SEND_LOGIN: "row-sendLogin",
  SEND_LINK: "row-sendLink",
  COPY_LOGIN: "row-copyLogin",
  COPY_LINK: "row-copyLink",
  OPEN_LINK: "row-openLink",
  DOCUMENT_REQUESTS: "row-documentRequests",
  ASSIGN_FORMS: "row-forms",
  ASSIGN_OWNERS: "row-assignOwners",
  CHANGE_GROUP: "row-changeGroup",
  CHANGE_PERSON: "row-changeGroup",
  GENERATE_DOCUMENT: "row-generateDocument",
  RUN_REPORT: "row-runReport",
  UPLOAD_FILES: "row-uploadFiles",
  DELETE_RECORDS: "row-deleteRecords",
  VIEW_PERSON: "row-viewPerson"
};
